import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore, { hasRole } from '../../stores/authStore';
import LoadingSpinner from '../ui/LoadingSpinner';

export default function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  if (isLoading) return <LoadingSpinner />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (requiredRole && !hasRole(user?.role, requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
